const domain = process.env.REACT_APP_COGNITO_DOMAIN ?? "";
const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID ?? "";

export const cognitoConfig = {
  domain,
  clientId,
} as const;
